/* MUI */
import { Box } from '@mui/material';
import { ApplicationNameLinkCell } from 'application/Shared/Components/ApplicationNameLinkCell';

/* Shared */
// TODO: Fix dependency cycle - SAAS-992
// eslint-disable-next-line import/no-cycle
import { AdminAppModal } from 'application/Shared/Modals';

/* React */
import React, { useState } from 'react';

const defaultFunction = () => {};

/**
 * @param {function} [onCloseModal] function to trigger when the modal is closed.
 * @param {string} [key] if we need a key for react rerendering purposes.
 * @param {string} [nameClassname] if we need an specific class for ApplicationNameLinkCell beyond the "link bold underline" classes.
 * @param {object} row the data for which to open the modal.
 * @returns JSX of the icon, clickable app name (that could link to the app's page), and, if included, the app's category and subCategory.
 *
 * Note: Always needs to be wrapped, at some higher level by the component `Application` in order to provide the context.
 * Remember you also need the props for ApplicationNameLinkCell. To know more about them, refer to that file.
 *
 * @example
 * <Application data={application}>
 *     <ApplicationNameAdminAppModalCell
 *         onCloseModal={() => this.rerender()}
 *         row={row}
 *         withCategory
 *     />
 * </Application>
 *
 */
export const ApplicationNameAdminAppModalCell = ({
    onCloseModal = defaultFunction,
    key,
    nameClassname,
    row,
    ...rest
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const appId = row.application?.id;

    const closingModal = () => {
        setIsModalOpen(false);
        onCloseModal();
    };

    return (
        <Box>
            {isModalOpen && (
                <AdminAppModal
                    open={isModalOpen}
                    applicationId={appId}
                    onCloseModal={() => closingModal()}
                />
            )}
            <Box key={key}>
                <ApplicationNameLinkCell
                    nameClassname={
                        row.application
                            ? `link bold underline ${nameClassname}`
                            : `bold ${nameClassname}`
                    }
                    onNameClick={() =>
                        row.application ? setIsModalOpen(true) : null
                    }
                    {...rest}
                />
            </Box>
        </Box>
    );
};
